<template>
  <div class="mx-input-container">
    <input v-if="isEdit" ref="inp" class="mx-input" placeholder="输入价格" @blur="changeValue" :value="value"/>
    <div v-else @click="handleClick" class="mx-input"><slot></slot>ms</div>
  </div>
</template>

<script>
export default {
  name: 'MXNumTag',
  props: {
    value: {
      type: [Number, String]
    }
  },
  data () {
    return {
      isEdit: false
    }
  },
  methods: {
    handleClick () {
      this.isEdit = true
      this.$nextTick(() => {
        this.$refs.inp.focus()
      })
    },
    isInteger (str) {
      return /^\d+$/.test(str)
    },
    changeValue (e) {
      if (e.target.value !== '' && !this.isInteger(e.target.value)) {
        return this.$message.error('数据格式不正确，只能是正整数')
      }
      this.isEdit = false
      if (e.target.value !== '') {
        this.$emit('input', e.target.value)
      }
    }
  }
}
</script>

<style scoped lang="less">
.mx-input-container{
    width: 100%;
    height: 100%;
}
.mx-input{
    display: inline-block;
    width: 100%;
    height: 100%;
    box-sizing: border-box;
}
</style>
